export const isGiraUrl = (url: string): boolean => url.startsWith('/rest/gira/');
